import Box from "@mui/material/Box"
import { styled } from "@mui/material/styles"

const Column = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}))

export const PaddedContentColumn = styled(Column)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingInline: theme.spacing(3),
  [theme.breakpoints.only("xs")]: {
    paddingInline: theme.spacing(2),
  },
}))

export const ColumnButRowOnMobile = styled(Column)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    flexDirection: "row",
  },
}))

export const CenterEverythingColumn = styled(Column)(() => ({
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minHeight: "200px",
}))

export default Column
